var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "form",
      {
        staticClass: "form form--location",
        attrs: { action: "#" },
        on: { submit: _vm.submitHandler }
      },
      [
        _c("fieldset", [
          _c(
            "div",
            { staticClass: "form-group form-group--big form-group--select" },
            [
              _vm.locations && _vm.locations.length > 0
                ? _c(
                    "multiselect",
                    {
                      staticClass: "multiselect--locations",
                      attrs: {
                        options: _vm.results,
                        placeholder:
                          _vm.lexicon && _vm.lexicon.location_or_postal_code,
                        "custom-label": _vm.completeAddress,
                        "internal-search": false,
                        loading: _vm.isLoading,
                        "track-by": "id"
                      },
                      on: {
                        select: _vm.onSelect,
                        "search-change": _vm.asyncFind
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "option",
                            fn: function(props) {
                              return [
                                _c(
                                  "span",
                                  { staticClass: "multiselect__option-text" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        (props.option.address_postal_code
                                          ? "CH-" +
                                            props.option.address_postal_code
                                          : "") +
                                          " " +
                                          props.option.address_city +
                                          (props.option.address_street
                                            ? ", " + props.option.address_street
                                            : "")
                                      )
                                    )
                                  ]
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        722447477
                      ),
                      model: {
                        value: _vm.selected,
                        callback: function($$v) {
                          _vm.selected = $$v
                        },
                        expression: "selected"
                      }
                    },
                    [
                      _vm._v(" "),
                      _vm.lexicon &&
                      _vm.lexicon.hasOwnProperty("location_no_result")
                        ? _c(
                            "span",
                            { attrs: { slot: "noResult" }, slot: "noResult" },
                            [_vm._v(_vm._s(_vm.lexicon.location_no_result))]
                          )
                        : _vm._e()
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "action action--submit-absolute",
                  attrs: { type: "submit", value: "Submit" }
                },
                [
                  _c("v-icon", { attrs: { name: "location" } }),
                  _vm._v(" "),
                  _c("span", { staticClass: "visually-hidden" }, [
                    _vm._v("Submit")
                  ])
                ],
                1
              )
            ],
            1
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _vm.parsedLink
        ? _c(
            "a",
            {
              staticClass: "action action--button",
              attrs: {
                href: _vm.parsedLink.url,
                target: _vm.parsedLink.target == "_blank" ? "_blank" : "_self"
              }
            },
            [
              _c("span", { staticClass: "action__text" }, [
                _vm._v(_vm._s(_vm.parsedLink.title))
              ])
            ]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }